import type { PanelDesignTokens, PanelTokenSections } from '@primeuix/themes/types/panel'

export const root: PanelTokenSections.Root = {
  background: '{content.background}',
  borderColor: '{content.border.color}',
  color: '{content.color}',
  borderRadius: '{content.border.radius}'
}

export const header: PanelTokenSections.Header = {
  background: '{primary.100}',
  color: '{text.color}',
  padding: 'calc(var(--spacing) * 6) calc(var(--spacing) * 4)',
  borderColor: 'transparent',
  borderWidth: '0',
  borderRadius: '0'
}

export const toggleableHeader: PanelTokenSections.ToggleableHeader = {
  padding: 'calc(var(--spacing) * 6) calc(var(--spacing) * 4)'
}

export const title: PanelTokenSections.Title = {
  fontWeight: '600'
}

export const content: PanelTokenSections.Content = {
  padding: 'calc(var(--spacing) * 6) calc(var(--spacing) * 4)'
}

export const footer: PanelTokenSections.Footer = {
  padding: '0 1.125rem 1.125rem 1.125rem'
}

export default {
  root,
  header,
  toggleableHeader,
  title,
  content,
  footer
} satisfies PanelDesignTokens
